// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownBlock_dropdown__YNY30","content":"DropdownBlock_content__K1VNV","open":"DropdownBlock_open__qoxLj"};